export default {
    install: (app) => {
        const logout = () => {
            //console.log("Logout is being called");
          };
      
          app.provide("logout", logout);
    },
  };